<template lang="pug">
  el-dialog.quotation-detail(
    :visible="visible"
    :title="$t('历史记录')"
    @close="$emit('closeDialog')"
    width="900px"
    :close-on-click-modal="true"
    center
  )
    title-bar {{ $t('项目信息') }}
    .info-display
      campaign-info-display(
        :campaignInfo="data"
      )
    .section-divider(v-if="data.quotation.length")
    template(v-if="data.quotation.length")
      title-bar {{ $t('原始报价') }}
      unistar-table-container(
        v-for="(s, i) in data.quotation"
        :starData="s"
        :key="i"
      )
</template>

<script>
import TitleBar from '@/components/TitleBar'
import CampaignInfoDisplay from './CampaignInfoDisplay'
import UnistarTableContainer from '@/components/UnistarTableContainer'
export default {
  components: {
    TitleBar,
    UnistarTableContainer,
    CampaignInfoDisplay
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default () {
        return {}
      }
    }
  }
}
</script>

<style lang="stylus">
.quotation-detail .unistar-table-container
  min-width unset
</style>
